import React, { Fragment, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import Header from '../../components/Header/Header.component';
import { ERROR_LABELS, VIEW_STATE, LABELS, LTS_ROUTES_PATH } from '../../constants/LTSConstants';
import { fetchStationList } from '../../utils/ApiHandlers';
import { LTSContext } from '../../context/LTSContext';
import { StationDetails } from '../../types/LTSTypes';
import { isEmpty } from '../../../../utils/isEmpty';
import ProgressView from '../../components/ProgressView/ProgressView.component';
import StationsList from './components/StationsList/StationsList.component';
import ErrorView from '../../components/ErrorView/ErrorView.component';
import HTMLHead from '../../components/HTMLHead/HTMLHead.component';
import '../../../../styles/LTSTrainStation.css';

const LTSTrainStation = (props) => {
  // ---------- props ----------
  const { data } = props;

  // ---------- hooks ----------
  const history = useHistory();

  // ---------- context ----------
  const ltsContext = useContext(LTSContext);
  const { trainDetail, stationsList, setBoardingStation } = ltsContext;

  // ---------- state ----------
  const [viewState, setViewState] = useState(VIEW_STATE.LOADING);
  const [stationList, setStationList] = useState(stationsList);

  // ---------- effects ----------
  useEffect(() => {
    if (!trainDetail?.trainNumber) {
      history.push(LTS_ROUTES_PATH.landingPage);
    }
  }, []);

  useEffect(() => {
    if (isEmpty(stationList)) {
      fetchStationsList();
    } else {
      setViewState(VIEW_STATE.SHOW_DETAIL);
    }
  }, [stationList]);

  // ---------- functions ----------
  const fetchStationsList = async () => {
    setViewState(VIEW_STATE.LOADING);

    const response = await fetchStationList(trainDetail.trainNumber);
    if (response && response.Stations) {
      setStationList(response.Stations);
      setViewState(VIEW_STATE.SHOW_DETAIL);
      return;
    }

    setViewState(VIEW_STATE.ERROR);
  };

  const handleOnStationClick = (stationDetail: StationDetails) => {
    setBoardingStation(stationDetail);
    history.push(LTS_ROUTES_PATH.landingPage);
  };

  // ---------- jsx ----------
  return (
    <Fragment>
      <HTMLHead data={data} blockSearchEngineIndexing />
      <Header title={LABELS.BOARDING_STATION_PAGE_HEADER_TITLE} />
      <main className="LTSTrainStation-main-wrapper">
        {viewState === VIEW_STATE.LOADING && <ProgressView />}
        {viewState === VIEW_STATE.ERROR && (
          <ErrorView
            title={ERROR_LABELS.station_picker_page_error}
            subtitle={ERROR_LABELS.try_again}
            onRetry={fetchStationsList}
          />
        )}
        {viewState === VIEW_STATE.SHOW_DETAIL && (
          <StationsList stationsList={stationList} onClick={handleOnStationClick} />
        )}
      </main>
    </Fragment>
  );
};

LTSTrainStation.propTypes = {
  data: PropTypes.object
};

export default LTSTrainStation;
